import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';

interface RehireIneligibleConfirmDialogProps {
    open: boolean;
    /** The reason that bars rejoining, named so the warning is about something specific. */
    reason?: string | null;
    confirmLabel: string;
    onGoBack: () => void;
    onConfirm: () => void;
}

/**
 * Shown before a separation on a reason code that permanently bars the rider from rejoining, both
 * to the person raising it and to the person approving it — they are two different people, and
 * each is making their own decision.
 *
 * <p>The body copy is Blue Dart's own wording and is used verbatim.
 *
 * <p>Dismissing by backdrop or Escape is Go back: the dangerous path is never the accidental one.
 */
const RehireIneligibleConfirmDialog: React.FC<
    RehireIneligibleConfirmDialogProps
> = ({ open, reason, confirmLabel, onGoBack, onConfirm }) => (
    <Dialog open={open} onClose={onGoBack} maxWidth="xs" fullWidth>
        <DialogTitle>This rider will not be eligible for rejoining</DialogTitle>
        <DialogContent dividers>
            <DialogContentText style={{ fontSize: 14, marginBottom: 0 }}>
                You have selected a deactivation reason that will permanently
                disable the employee&apos;s rejoining eligibility. Please
                confirm your selection before proceeding.
            </DialogContentText>
            {!!reason && (
                <DialogContentText
                    style={{ fontSize: 14, marginTop: 12, marginBottom: 0 }}
                >
                    <strong>Reason:</strong> {reason}
                </DialogContentText>
            )}
        </DialogContent>
        <DialogActions>
            {/* Not "Cancel": nothing is being cancelled, the form is still there to go back to. */}
            <Button onClick={onGoBack}>Go back</Button>
            <Button color="secondary" variant="contained" onClick={onConfirm}>
                {confirmLabel}
            </Button>
        </DialogActions>
    </Dialog>
);

export default RehireIneligibleConfirmDialog;
